<template>
  <MdfeTable ref="MdfeTable" />
</template>
<script>
import MdfeTable from './MdfeTable'

export default {
  name: 'CTe',
  components: {
    MdfeTable,
  },
  methods: {
    //Init
    init(params) {
      this.search(params)
    },

    search(values) {
      this.$refs.MdfeTable.search(values)
      this.$emit('update')
    },

    //Handlers
    handlerNew() {
      this.$router.push('/routes/add/')
    },

  }
}
</script>
<style lang="scss" scoped>
</style>